export interface MenuProps {
  show: boolean;
  title: string;
  iconName: string;
  modelType?: string;
  rootType?: string;
  renderChild?: any;
  defaultChildKey?: any;
  tips?: string;
  value: string | Record<string, Partial<MenuProps> & { color?: string }>;
}

const createTips = title => {
  return `提示：以下${title}仅为示例样式，实际以真实数据为准`;
};

export const getBaseMenus = (): Array<Array<string | MenuProps>> => {
  return [
    [
      '101',
      {
        show: true,
        title: '主题色、大标题、小标题、页码、水印',
        iconName: 'yanse',
        modelType: 'BASIC_STYLE',
        value: {
          // 主题
          '101_1': {
            show: true,
            tips: '',
            title: '主题色',
            color: '',
            modelType: 'BASIC_STYLE_COLOR',
            value: ''
          },
          // 标题
          '101_2': {
            show: true,
            tips: createTips('标题文字'),
            title: '大标题',
            modelType: 'BASIC_STYLE_BIG_TITLE',
            value: ''
          },
          // 子标题
          '101_3': {
            show: true,
            tips: createTips('标题文字'),
            title: '小标题',
            modelType: 'BASIC_STYLE_SMALL_TITLE',
            value: ''
          },
          // 页码
          '101_4': {
            show: true,
            tips: '',
            title: '页码',
            modelType: 'BASIC_STYLE_PAGE_NO',
            value: ''
          },
          // 水印
          '101_5': {
            show: false,
            tips: '',
            title: '水印',
            modelType: 'BASIC_STYLE_WATERMARK',
            value: ''
          }
        }
      }
    ],
    [
      '102',
      {
        show: true,
        tips: createTips('封面'),
        title: '封面',
        iconName: 'fengmian',
        modelType: 'COVER',
        value: ''
      }
    ],
    [
      '103',
      {
        show: true,
        tips: createTips('目录'),
        title: '目录',
        iconName: 'mulu',
        modelType: 'DIRECTORY',
        value: ''
      }
    ],
    [
      '1',
      {
        show: true,
        tips: createTips('项目背景介绍'),
        title: '项目背景介绍',
        iconName: 'jieshao',
        modelType: 'BACKGROUND_INTRO',
        value: ''
      }
    ],
    [
      '2',
      {
        show: true,
        tips: createTips('样本采集范围'),
        title: '样本采集范围',
        iconName: 'fanwei',
        modelType: 'SAMPLE_SCOPE',
        value: ''
      }
    ],
    [
      '3',
      {
        show: true,
        tips: createTips('项目总览'),
        title: '项目总览',
        iconName: 'zonglan',
        modelType: 'PROJECT_OVERVIEW',
        value: ''
      }
    ],
    [
      '4',
      {
        show: true,
        tips: '',
        title: '项目执行人数据统计',
        iconName: 'tongji',
        renderChild: true,
        defaultChildKey: '4_1',
        // !有子级必填
        rootType: 'PROJECT_EXE_STAT',
        // modelType: 'PROJECT_EXE_STAT_BEFORE', // UI结构无modelType
        value: {
          // 数据前处理
          '4_1': {
            show: true,
            tips: createTips('数据前处理'),
            title: '数据前处理',
            modelType: 'PROJECT_EXE_STAT_BEFORE',
            value: ''
          },
          // 参与人物执行的性别分析
          '4_2': {
            show: true,
            tips: '',
            title: '参与任务执行的性别分析',
            modelType: 'PROJECT_EXE_STAT_GENDER',
            value: {
              // 项目执行人性别分布
              '4_2_1': {
                show: true,
                tips: createTips('模块内容'),
                title: '项目执行人性别分布',
                modelType: 'PROJECT_EXE_STAT_GENDER_SEX',
                value: ''
              },
              // 项目执行人年龄对比分析
              '4_2_2': {
                show: true,
                tips: '',
                title: '项目执行人年龄对比分析',
                modelType: 'PROJECT_EXE_STAT_GENDER_AGE',
                value: ''
              },
              // 项目执行人男性年龄分布
              '4_2_3': {
                show: true,
                tips: '',
                title: '项目执行人男性年龄分布',
                modelType: 'PROJECT_EXE_STAT_GENDER_AGE_MAN',
                value: ''
              },
              // 项目执行人女性年龄分布
              '4_2_4': {
                show: true,
                tips: '',
                title: '项目执行人女性年龄分布',
                modelType: 'PROJECT_EXE_STAT_GENDER_AGE_WOMAN',
                value: ''
              }
            }
          },
          // 项目参与人完成的任务区间分布
          '4_3': {
            show: true,
            tips: '',
            title: '项目参与人完成的任务区间分布',
            modelType: 'PROJECT_EXE_STAT_INTERVAL',
            value: {
              // 项目参与人完成任务区间
              '4_3_1': {
                show: true,
                tips: createTips('模块内容'),
                title: '项目参与人完成任务区间',
                modelType: 'PROJECT_EXE_STAT_INTERVAL_TASK',
                value: ''
              },
              // 百分比分析
              '4_3_2': {
                show: true,
                tips: '',
                title: '百分比分析',
                modelType: 'PROJECT_EXE_STAT_INTERVAL_PERCENT',
                value: ''
              },
              // 中位数、众数、四分位数分析
              '4_3_3': {
                show: true,
                tips: '',
                title: '中位数、众数、四分位数分析',
                modelType: 'PROJECT_EXE_STAT_INTERVAL_ZWS',
                value: ''
              }
            }
          }
        }
      }
    ],
    [
      '18',
      {
        show: true,
        tips: '',
        title: '专区历史数据浏览效果评价',
        iconName: 'zhuanqulishi',
        renderChild: true,
        defaultChildKey: '18_1',
        // !有子级必填
        rootType: 'ZONE_HISTORY_EVALUATION',
        value: {
          // 各篇浏览内容排行
          '18_1': {
            show: true,
            tips: createTips('各篇浏览内容排行'),
            title: '各篇浏览内容排行',
            modelType: 'ZONE_HISTORY_EVALUATION_RANK',
            value: ''
          },
          // 浏览分布区域热力图
          '18_2': {
            show: true,
            tips: createTips('浏览分布区域热力图'),
            title: '浏览分布区域热力图',
            modelType: 'ZONE_HISTORY_EVALUATION_HOT',
            value: ''
          },
          // 单日浏览走势图
          '18_3': {
            show: true,
            tips: createTips('单日浏览走势图'),
            title: '单日浏览走势图',
            modelType: 'ZONE_HISTORY_EVALUATION_TREND',
            value: ''
          },
          // 各篇内容单日最大浏览量排名
          '18_4': {
            show: true,
            tips: createTips('各篇内容单日最大浏览量排名'),
            title: '各篇内容单日最大浏览量排名',
            modelType: 'ZONE_HISTORY_EVALUATION_DAY',
            value: ''
          }
        }
      }
    ],
    [
      '19',
      {
        show: true,
        tips: '',
        title: '本次专区反馈效果评价',
        iconName: 'bencizhuanqufankui',
        renderChild: true,
        defaultChildKey: '19_1',
        // !有子级必填
        rootType: 'ZONE_EVALUATION_CURRENT',
        value: {
          // 各篇内容反馈排行
          '19_1': {
            show: true,
            tips: createTips('各篇内容反馈排行'),
            title: '各篇内容反馈排行',
            modelType: 'ZONE_EVALUATION_CURRENT_RANK',
            value: ''
          },
          // 反馈分布区域热力图
          '19_2': {
            show: true,
            tips: createTips('反馈分布区域热力图'),
            title: '反馈分布区域热力图',
            modelType: 'ZONE_EVALUATION_CURRENT_HOT',
            value: ''
          },
          // 单日反馈走势图
          '19_3': {
            show: true,
            tips: createTips('单日反馈走势图'),
            title: '单日反馈走势图',
            modelType: 'ZONE_EVALUATION_CURRENT_TREND',
            value: ''
          },
          // 各篇内容单日最大反馈量排名
          '19_4': {
            show: true,
            tips: createTips('各篇内容单日最大反馈量排名'),
            title: '各篇内容单日最大反馈量排名',
            modelType: 'ZONE_EVALUATION_CURRENT_DAY',
            value: ''
          }
        }
      }
    ],
    [
      '20',
      {
        show: true,
        tips: createTips('推广相关问卷数据分析'),
        title: '推广相关问卷数据分析',
        iconName: 'shujufenxi',
        modelType: 'PROMOTION_ANALYSIS',
        value: ''
      }
    ],
    [
      '21',
      {
        show: true,
        tips: '',
        title: '各篇内容有效点击量排名',
        iconName: 'neirongpaiming',
        renderChild: true,
        defaultChildKey: '21_1',
        // !有子级必填
        rootType: 'CONTENT_HIT_RATE_RANKING',
        value: {
          '21_1': {
            show: true,
            tips: createTips('各篇内容有效点击排行'),
            title: '各篇内容有效点击排行',
            modelType: 'CONTENT_HIT_RATE_RANKING_CLICK',
            value: {
              '21_1_1': {
                show: true,
                tips: createTips('各篇内容有效点击排行'),
                title: '各篇内容有效点击量排名',
                modelType: 'CONTENT_HIT_RATE_RANKING_CLICK_TABLE',
                value: ''
              },
              // 项目执行人年龄对比分析
              '21_1_2': {
                show: true,
                tips: '请选择图形样式',
                title: '各篇内容有效点击排行',
                modelType: 'CONTENT_HIT_RATE_RANKING_CLICK_GRAPH',
                value: ''
              }
            }
          },
          '21_2': {
            show: true,
            tips: createTips('有效点击分布区域热力图'),
            title: '有效点击分布区域热力图',
            modelType: 'CONTENT_HIT_RATE_RANKING_MAP',
            value: ''
          },
          '21_3': {
            show: true,
            tips: createTips('单日有效点击走势图'),
            title: '单日有效点击走势图',
            modelType: 'CONTENT_HIT_RATE_RANKING_TREND',
            value: ''
          },
          '21_4': {
            show: true,
            tips: createTips('单日点击量Top5日期分布图'),
            title: '单日点击量Top5日期分布图',
            modelType: 'CONTENT_HIT_RATE_RANKING_DISTRIBUTE',
            value: ''
          },
          '21_5': {
            show: true,
            tips: createTips('单日点击量Top5占周期总有效点击量占比分析图'),
            title: '单日点击量Top5占周期总有效点击量占比分析图',
            modelType: 'CONTENT_HIT_RATE_RANKING_PROPORTION',
            value: ''
          },
          '21_6': {
            show: true,
            tips: createTips('各篇内容单日最大有效点击量排名'),
            title: '各篇内容单日最大有效点击量排名',
            modelType: 'CONTENT_HIT_RATE_RANKING_VALID',
            value: ''
          }
        }
      }
    ],
    [
      '22',
      {
        show: true,
        tips: createTips('单篇内容有效点击量分析图'),
        title: '单篇内容有效点击量分析图',
        iconName: 'dianjiliangfenxi',
        modelType: 'ARTICLE_CLICK_ANALYSIS',
        value: ''
      }
    ],
    [
      '5',
      {
        show: true,
        tips: createTips('项目相关分析模块'),
        title: '项目相关分析模块',
        iconName: 'diaoyan',
        modelType: 'PROJECT_RESEARCH',
        value: {
          '5_1': {
            show: true,
            tips: createTips('模块内容'),
            title: '',
            modelType: 'PROJECT_RESEARCH_OVERVIEW',
            value: ''
          },
          '5_2': {
            show: true,
            tips: '请选择下面图形样式，最少选择6种',
            title: '',
            modelType: 'PROJECT_RESEARCH_CHARTS',
            value: ''
          },
          '5_3': {
            show: true,
            tips: '',
            title: '百分比分析',
            modelType: 'PROJECT_RESEARCH_PERCENT',
            value: ''
          },
          '5_4': {
            show: true,
            tips: '',
            title: '中位数、众数、四分位数分析',
            modelType: 'PROJECT_RESEARCH_ZWS',
            value: ''
          }
        }
      }
    ],
    [
      '6',
      {
        show: true,
        tips: '',
        title: '交叉分析表与卡方分析',
        iconName: 'fengxi',
        modelType: 'CROSS_KAFANG_ANALYSIS',
        value: {
          '6_1': {
            show: true,
            tips: createTips('模块内容'),
            title: '',
            modelType: 'CROSS_KAFANG_ANALYSIS_TABLE',
            value: ''
          },
          '6_2': {
            show: true,
            tips: '图形样式',
            title: '',
            modelType: 'CROSS_KAFANG_ANALYSIS_CHARTS',
            value: ''
          },
          '6_3': {
            show: true,
            tips: '请选择卡方分析表格样式',
            title: '',
            modelType: 'CROSS_KAFANG_ANALYSIS_CHARTS_TABLE',
            value: ''
          }
        }
      }
    ],
    [
      '7',
      {
        show: true,
        tips: createTips('模块内容'),
        title: '单因素与多样本比较',
        iconName: 'bijiao',
        modelType: 'SINGLE_FACTOR_MULTI_SAMPLE',
        value: ''
      }
    ],
    [
      '16',
      {
        show: true,
        tips: createTips('相关性热图'),
        title: '相关性热图',
        iconName: 'retu',
        modelType: 'HEAT_MAP',
        value: ''
      }
    ],
    [
      // 示列分享
      '8',
      {
        show: true,
        tips: createTips('示例分享'),
        title: '示例分享',
        iconName: 'fenxiang',
        modelType: 'EXAMPLE_SHARING',
        value: ''
      }
    ],
    [
      '9',
      {
        show: true,
        tips: createTips('项目执行流程'),
        title: '项目执行流程',
        iconName: 'liucheng',
        modelType: 'PROJECT_EXE_FLOW',
        value: ''
      }
    ],
    [
      '10',
      {
        show: true,
        tips: createTips('项目执行进度'),
        title: '项目执行进度',
        iconName: 'jingdu',
        modelType: 'PROJECT_EXE_PROGRESS',
        value: ''
      }
    ]
  ];
};
